export const vehicles = [
  { id: 'V-1042', type: 'Delivery Van', status: 'active', fuel: 78, health: 92, driver: 'J. Miller', location: 'Sector 4, North Ave', nextService: '2024-05-12', notes: 'Brake pads replaced last week.' },
  { id: 'V-1043', type: 'Heavy Truck', status: 'maintenance', fuel: 45, health: 31, driver: 'Unassigned', location: 'Depot Bay 2', nextService: 'In Progress', notes: 'Scheduled engine diagnostics.' },
  { id: 'V-1044', type: 'Delivery Van', status: 'active', fuel: 92, health: 88, driver: 'S. Connor', location: 'District 9, Industrial', nextService: '2024-06-01', notes: 'Clean record.' },
  { id: 'V-1045', type: 'Utility Box', status: 'idle', fuel: 12, health: 95, driver: 'R. Deckard', location: 'HQ Parking', nextService: '2024-05-20', notes: 'Requires refueling before next shift.' },
  { id: 'V-1046', type: 'Delivery Van', status: 'active', fuel: 65, health: 74, driver: 'M. Vance', location: 'Downtown Hub', nextService: '2024-05-15', notes: 'Slight tire pressure variance.' },
  { id: 'V-1047', type: 'Heavy Truck', status: 'warning', fuel: 22, health: 45, driver: 'T. Anderson', location: 'Highway 61, Mile 4', nextService: 'IMMEDIATE', notes: 'Engine temperature spike reported.' },
];

export const routes = [
  { id: 'RT-884', vehicleId: 'V-1042', progress: 65, stops: 12, completed: 8, eta: '14:30', status: 'on-time' },
  { id: 'RT-885', vehicleId: 'V-1044', progress: 30, stops: 8, completed: 2, eta: '16:15', status: 'delayed' },
  { id: 'RT-886', vehicleId: 'V-1046', progress: 90, stops: 20, completed: 18, eta: '11:45', status: 'on-time' },
];

export const issues = [
  { id: 'TKT-091', title: 'Engine Temp Warning', vehicle: 'V-1047', severity: 'high', status: 'open', time: '10:42 AM' },
  { id: 'TKT-092', title: 'Route Blocked - Rerouting', vehicle: 'V-1044', severity: 'medium', status: 'resolved', time: '09:15 AM' },
  { id: 'TKT-093', title: 'Scheduled Brake Pad Check', vehicle: 'V-1043', severity: 'low', status: 'open', time: 'Yesterday' },
];

export const dailyReports = [
  { date: '2024-04-26', efficiency: '94%', fuelCost: '$450.20', incidents: 0, uptime: '99.8%' },
  { date: '2024-04-25', efficiency: '88%', fuelCost: '$512.45', incidents: 1, uptime: '98.2%' },
  { date: '2024-04-24', efficiency: '91%', fuelCost: '$480.12', incidents: 0, uptime: '100%' },
];

export const stats = {
  activeFleet: '84%',
  fuelEfficiency: '14.2 mpg',
  totalIssues: 3,
  dailyCost: '$1,240'
};